import { useRequest } from "../../../app/hooks/useRequest";
import {
  confirmIpAddressRequest,
  loginRequest,
} from "../AuthenticationRequests";

export const useLogin = () => useRequest(loginRequest, false);
export const useConfirmIpAddress = () =>
  useRequest(confirmIpAddressRequest, false);
